import locale from "csi/locale";
import { validateValue } from "csi/middleware/rollup/rollupService";

/**
 * Validate the expression and throw error message specified on the ValueAttributeDefinition node
 * @param {ActionController} ac
 * @param {Context} ctx
 */
export function validateActionSpecValue(ac, ctx): void {
	const node = ctx.getCache().getNode(ac.m_urlNode);
	if (!node) {
		return;
	}

	const path = node.$Type == "SpecificationDataSheetResponseItem"
		? "Child:SpecDefinition/Child:ValueAttributeDefinition"
		: "Child:Actual/Child:Definition/Child:ValueAttributeDefinition";

	const vad = ctx.getCache().getPathNode(node, path);
	if (!vad) {
		return;
	}

	const validationExpr = vad.ValidationExpression;

	if (validationExpr) {
		const validationResult = validateValue(ac.newValue, validationExpr);
		if (validationResult === false) {
			throw new Error(vad.ValidationErrorMessage[locale.getLocale()]);
		}
	}
}